import React, { useEffect, useState } from 'react';

import { hashHistory } from 'react-router';

import { BackLink } from '../../components/atoms';
import { LoadingSpinner, Page } from '../../components/layouts';
import { NavList } from '../../components/molecules';
import { NavListItemProps } from '../../components/molecules/NavListItem/NavListItem';
import { PageHeader } from '../../components/partials/PageHeader';
import { analyticsService } from '../../core/services';
import { DispatchProps, StateProps } from './index';
import { HistoryUnavailable } from './partials';
import { OrderHistoryItem } from './partials/OrderHistoryItem';

type Props = StateProps & DispatchProps;

export function OrderHistory(props: Props): JSX.Element {
  const {
    actions,
    afterProfilePanelUrl,
    countryCode,
    currentLang,
    lastRestaurantUrl,
    ordersHistory,
    translate,
  } = props;

  const [historyRequested, setHistoryRequested] = useState(false);

  useEffect(() => {
    if (ordersHistory.status === 'pending' && !historyRequested) {
      actions.loadOrderHistory();
      setHistoryRequested(true);
    }
  }, [ordersHistory.status, historyRequested]);

  const handleStartOrdering = (): void => {
    hashHistory.push(lastRestaurantUrl);
  };

  const trackBackSelected = (): void => {
    const eventData = {
      amp_label: 'Back Selected',
      amp_view: 'Order History',
    };
    analyticsService.track(eventData);
  };

  const getPreviousOrderList = (): NavListItemProps[] => {
    if (ordersHistory.status !== 'success') {
      return null;
    }

    const previousOrdersList = ordersHistory?.data.map(
      (orderedItem): NavListItemProps => ({
        elements: [
          <OrderHistoryItem
            countryCode={countryCode}
            currentLang={currentLang}
            key={`ordered-item-${orderedItem.OrderId}`}
            orderedItem={orderedItem}
            translate={translate}
          />,
        ],
        linkId: `history-${orderedItem.OrderId}`,
        linkPath: `/history/${orderedItem.OrderId}`,
      }),
    );

    return previousOrdersList;
  };

  const renderPageContent = (): JSX.Element => {
    if (ordersHistory.status === 'pending') {
      return <LoadingSpinner variant="panel" />;
    }

    if (ordersHistory.status !== 'success') {
      return null;
    }

    if (!ordersHistory.data.length) {
      return (
        <HistoryUnavailable
          handleStartOrdering={handleStartOrdering}
          translate={translate}
        />
      );
    }

    return <NavList items={getPreviousOrderList()} />;
  };

  return (
    <Page pageName="history">
      <PageHeader
        showProfileMenu
        title={translate('HistoryPage_PreviousOrders_heading')}
      >
        <BackLink
          label={translate('Back')}
          linkPath={afterProfilePanelUrl}
          onClick={trackBackSelected}
        />
      </PageHeader>

      <article className="fd-content__main">{renderPageContent()}</article>
    </Page>
  );
}
